import React from "react";

import TextButton from "@sellernote/ui/src/sds-v1/components/button/TextButton";
import { IconType } from "@sellernote/ui/src/sds-v1/components/Icon/DATA";

import Styled from "./index.styles";

export default function SupportMenuSection({
  desc,
  button,
}: {
  desc: React.ReactNode;
  button: {
    label: React.ReactNode;
    handleClick: () => void;
    iconType?: IconType;
  };
}) {
  return (
    <Styled.supportMenuSection>
      <p className="desc">{desc}</p>

      <TextButton
        theme="withIcon"
        size="13px"
        label={button.label}
        icon={button.iconType ? button.iconType : "arrowRight"}
        handleClick={button.handleClick}
      />
    </Styled.supportMenuSection>
  );
}
